import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
    import { useRoute } from 'vue-router'
    import MainTemplate from '@/components/MainTemplate.vue'
    import AbstractSubmissionReceipt from '@/components/reviewSubmission/AbstractSubmissionReceipt.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SubmissionReceipt',
  setup(__props, { expose: __expose }) {

    const route = useRoute()

    const receiptNumber = ref(route.params.receiptNumber as string)

    const updateReceipt = (newReceiptNumber: string) => {
        receiptNumber.value = newReceiptNumber
    }

    __expose({ updateReceipt })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainTemplate, null, {
    default: _withCtx(() => [
      _createVNode(AbstractSubmissionReceipt, {
        class: "self",
        header: 'termsAndConditions.reviewSubmission.header',
        reason: 'termsAndConditions.reviewSubmission.reason',
        title: 'termsAndConditions.reviewSubmission.title'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('termsAndConditions.reviewSubmission.highLight')) + " : " + _toDisplayString(receiptNumber.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})